//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import downloadImgs from '@/mixins/downloadImgs'
export default {
  mixins: [downloadImgs],
  props: {
    desc: {
      type: String,
      default: '',
    },
    src: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    blankVisible: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      imgUrl: ""
    }
  },
  mounted() {
    this.downFile();
  },
  methods: {
    // 下载文件
		downFile() {
      const newUrl = this.src.split("survey-file")[1];
			const arr = newUrl.split("fileId=");
			this.ssdpRequestDtgw1({
        code: 'survey_download',
        headers: {
          's-crc-tpl-code': 'EMAP_FILE_DOWN',
          'content-type':'application/json',
        },
        params: {
          fileId: arr[1]
        },
        responseType: "blob",
        isUpload: false,
      })
      .then((res) => {
        const blobUrl = URL.createObjectURL(res.data);
        this.imgUrl = blobUrl;
      });
		}
  },
}
